// @flow
import trackedProfiles from './tracked-profiles';
import PageDwell from './pageDwell';

type Props = {|
  profileName?: string,
  trackingId?: number,
  isSponsored?: boolean, // all sponsored trips need dwell time tracking
|};

export default function DwellTracking(props: Props) {
  const profileName = props.profileName || '';
  const trackingId = props.trackingId || 0;
  /* eslint-disable no-restricted-globals */
  if (typeof window !== 'undefined' && (trackedProfiles.has(profileName) || props.isSponsored)) {
    return PageDwell(`${profileName}_${window.pageServlet}_${trackingId}`);
  }
  return null;
}
